import { AuthType } from "./auth.type";

export const setAuth = (data) => ({
    type: AuthType.setAuth,
    payload: data
    
  });

  

  export const setProfile = (data) => ({
    type: AuthType.setProfile,
    payload: data
    
  });

  export const setAccessDashBoard = (data) => ({
    type: AuthType.setAccessDashBoard,
    payload: data
    
  });

  export const setCallBackUrl = (data) => ({
    type: AuthType.setCallBackUrl,
    payload: data
    
  });

  export const resetAuth ={
    type: AuthType.RESETAUTH
  }